<template>
  <div>
    <b-form-group
      horizontal
      label="Search:"
      label-size="lg"
      label-for="txtSearchBox"
    >
      <b-form-input
        type="text"
        id="txtSearchBox"
        v-model="searchString"
        placeholder="Enter volunteer name or pin code"
      ></b-form-input> </b-form-group
    >&nbsp; <b-button size="lg" @click="submit">Search</b-button>&nbsp;
    <b-button
      size="lg"
      tag="button"
      :to="{ name: 'addVolunteer', params: { id: $route.params.id } }"
      >Add</b-button
    >

    <div v-show="!volunteers.length">
      <b-alert show dismissible>No results match your search</b-alert>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th scope="col">&nbsp;</th>
          <th scope="col">Code</th>
          <th scope="col">Name</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="vol in volunteers" :key="vol.id">
          <td>
            <router-link
              :to="{
                name: 'editVolunteer',
                params: { volId: vol.id, locId: $route.params.id }
              }"
              >Edit</router-link
            >
          </td>
          <td>{{ vol.pinCode }}</td>
          <td>{{ vol.name }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "Volunteers",
  data: () => ({
    volunteers: [],
    searchString: null
  }),
  methods: {
    onLoad(id) {
      this.axios
        .get(process.env.VUE_APP_API_URL + "volunteers/findbylocation/" + id)
        .then(response => (this.volunteers = response.data))
        .catch(err => console.log(err));
    },
    async submit() {
      try {
        this.volunteers = (await this.axios.get(
          process.env.VUE_APP_API_URL + "volunteers/search/" + this.searchString
        )).data;
      } catch (err) {
        console.log(err);
      }
    }
  },
  mounted() {
    this.onLoad(this.$route.params.id);
  }
};
</script>
